import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette } from '../../../../../assets/styles/themes/tokens';
import { getDateTimeInGermanFormat } from '../../../../../utils/format';

interface ArtifactCardSubheaderProps {
	createdAt?: number;
}

const ArtifactCardSubheader: React.FC<ArtifactCardSubheaderProps> = ({ createdAt }) => {
	const { t } = useTranslation();

	if (!createdAt) return null;

	return (
		<Typography variant="caption2" sx={{ color: palette.text.secondary }}>
			{t('Created') + ' • ' + getDateTimeInGermanFormat(createdAt)}
		</Typography>
	);
};

export default ArtifactCardSubheader;
